@if (!isQuickBet) {
    @if (selectionVisible) {
        <quickbet-panel
            [title]="panelTitle"
            [showCloseIcon]="true"
            [selection]="selectionData"
            (placeBetFn)="placeBet()"
            (closeFn)="addToBetslip($event)"
            (addToBetslipFn)="addToBetslip()"
            data-crlat="quickbetPanel"
            [isLuckyDip]="isLuckyDip"
            [luckyDipCmsData]="luckyDipCmsData"
            [luckyDipMarketName]="luckyDipMarketName"
            [isWSdisabled]="isWSdisabled"
            [betslipType]="betslipType"
            [isQuickBet]="isQuickBet">
        </quickbet-panel>
    }
}
@if (isQuickBet) {
    @if (selectionVisible) {
        <quickbet-panel-updated
            #newQuickBetPanel
            [title]="panelTitle"
            [showCloseIcon]="true"
            [selection]="selectionData"
            (placeBetFn)="placeBet()"
            (closeFn)="addToBetslip($event)"
            (addToBetslipFn)="addToBetslip()"
            (openFullOverlayFn)="openFullOverlay()"
            (closePanelFn)="closePanel()"
            data-crlat="quickbetPanel"
            [isLuckyDip]="isLuckyDip"
            [luckyDipCmsData]="luckyDipCmsData"
            [luckyDipMarketName]="luckyDipMarketName"
            [isWSdisabled]="isWSdisabled"
            [betslipType]="betslipType"
            [isQuickBet]="isQuickBet"
            [showFullOverlay]="showFullOverlay">
        </quickbet-panel-updated>
    }
}
